import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import pkg from '../../package.json'
import { LOCAL_STORAGE_KEYS } from '../configs/constants'
import { accountResponse } from '../services/login/interface'

interface IAppStore {
  token: string | null;
  isOpenNavigationMenu: boolean;
  socket_version: string | null;
  switchNavigationMenu: () => void;
  setToken: (token: string | null) => void;
  logout: () => void;
  setAccountData: (data: accountResponse) => void;
  updateSocketVersion: () => void;
  setSocketVersion: (version: string) => void;
}

interface Store extends IAppStore, accountResponse {}

const useAppStore = create<Store>()(
  persist(set => ({
    token: localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN),
    isOpenNavigationMenu: false,
    socket_version: null,
    ride_types: null,
    fare_types: null,
    payment_types: null,
    equipment_codes: null,
    companions: [],
    user: null,
    clients: [],
    pcas: [],
    permissions: {},
    companion_price: 0,
    setToken: token => {
      localStorage.setItem(LOCAL_STORAGE_KEYS.TOKEN, token || '')
      set({ token })
    },
    setAccountData: data => {
      set(data)
    },
    logout: () => {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN)
      set({ token: null })
    },
    switchNavigationMenu: () => set(state => ({ isOpenNavigationMenu: !state.isOpenNavigationMenu })),
    updateSocketVersion: () => set({ socket_version: pkg.version }),
    setSocketVersion: (version: string) => set({ socket_version: version })
  }), {
    name: LOCAL_STORAGE_KEYS.APP_STORAGE,
    onRehydrateStorage: () => state => {
      if (!state) return
      if (state.socket_version === null || state.socket_version !== pkg.version) {
        state.setSocketVersion(pkg.version)
      }
    }
  })
)

export default useAppStore
